module.exports = __webpack_public_path__ + "static/media/java-beginner.e26bd982.png";


//////////////////
// WEBPACK FOOTER
// ./src/resources/validations/images/levels/java-beginner.png
// module id = 1455
// module chunks = 146